import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import * as XLSX from 'xlsx';


import { SocketContext } from '../context/SocketContext'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'
import { useHideMenu } from '../hooks/useHideMenu'
// import { UseCurrencyFormat } from '../hooks/useCurrencyFormat';
import { useGetPantallas } from '../hooks/useGetPantallas';

import { SelectElement } from "../components/selectElement";
import { NoAcceso } from '../components/NoAcceso';
import LoadingOverlay from '../components/LoadingOverlay';



const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
}

     
// let usuario = getUsuarioStorage();
// const entidad = usuario.entidad;



export const ListaPacientes = () => {

    let [usuario] = useState( getUsuarioStorage() )
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const navigate = useNavigate();
    useEffect(() => {
      if(usuario.uidUsuario === null){
          // return <Navigate to="/ingreso" />
          navigate("/Ingreso")
      }
    }, [usuario.uidUsuario, navigate])


    useHideMenu(false);
    
    // const formatoNumero = (numero) => {
    //     return UseCurrencyFormat(numero);
    // }
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [ atencion, setAtencion ] = useState([]);
    const [modulo, setModulo] = useState([]);
    const [agente, setAgente] = useState([]);
    const [paciente, setPaciente] = useState([]);
    
    const [ listaAtenciones, setListaAtenciones ] = useState([]);


    const [ fechaInicio, setFechaInicio ] = useState('');
    const [ fechaFinal, setFechaFinal ] = useState('');

    const [ moduloSeleccionado, setModuloSeleccionado ] = useState('');
    const [ atencionSeleccionado, setAtencionSeleccionado ] = useState('');
    const [ agenteSeleccionado, setAgenteSeleccionado ] = useState('');

 
    const datos={
        entidad,
    }

    // Select tipos Atencion
    useEffect(() => {
        async function fetchAtenciones() {
            setIsLoading(true)
            await socket.emit('select-TipoAtencion', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidTipoAtencion, label: item.tipoAtencion.toUpperCase() } ) )
                setAtencion( opciones )
            })
        }

        fetchAtenciones();
               
        return () => {
            socket.off('select-TipoAtencion')
        }
    }, [ socket ])


    // Select modulos
    useEffect(() => {
        async function fetchModulos() {
            setIsLoading(true)
            await socket.emit('select-Modulos', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
                setModulo( opciones )
            })
        }

        fetchModulos();
               
        return () => {
            socket.off('select-Modulos')
        }
    }, [ socket ])

    // Select Agentes
    useEffect(() => {
        async function fetchAgentes() {
            setIsLoading(true)
            await socket.emit('select-Usuarios', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() } ) )
                setAgente( opciones )
            })
        }

        fetchAgentes();
               
        return () => {
            socket.off('select-Modulos')
        }
    }, [ socket ])

    
    useEffect( () => {
        
        const fecini = document.getElementById('fechaInicio');
        if( fecini ) setFechaInicio(document.getElementById('fechaInicio').value);

        const fecfin = document.getElementById('fechaFinal');
        if( fecfin ) setFechaFinal(document.getElementById('fechaFinal').value);

        if( fechaInicio === "" || fechaFinal === "" ) return;

        datos.fechaInicio = fechaInicio;
        datos.fechaFinal = fechaFinal;
        datos.modulo = moduloSeleccionado;
        datos.atencion = atencionSeleccionado;
        datos.uidAgente = agenteSeleccionado;
        datos.paciente = paciente;
       
        async function fetchListaAtenciones() {
            setIsLoading(true);
            await socket.emit('lista-Pacientes', datos, async ( lista ) => {
                
                setListaAtenciones(lista);
                setIsLoading(false);
                console.log(lista);   
            })
        }    
       
        fetchListaAtenciones();
        
        return () => {
            socket.off('lista-Atenciones');
        }
        
    }, [ socket, atencionSeleccionado, moduloSeleccionado, fechaInicio, fechaFinal, agenteSeleccionado, paciente ])

    
    const handleFechaChange = ( ev ) =>{
        const fechaFinal = document.getElementById('fechaFinal');
        setFechaInicio(ev.target.value)
        setFechaFinal(ev.target.value)
        fechaFinal.setAttribute("min", ev.target.value);
        fechaFinal.value= ev.target.value;

    }

    const onChangeName = ( ev ) =>{
        if (ev.target.length < 2 ) return false;  
        // console.log(paciente)
        setPaciente( ev.target.value );
    }

    const exportToExcel = ( tabla, name) => {
        // const data = lista;
        // // const headers = ['fecha', 'Módulo', 'Cantidad'];
        
        // // return console.log(data)
        
        // const sheetName= "Atenciones x módulo" ;
        // const worksheet = XLSX.utils.json_to_sheet(data);
        // const workbook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        // const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // const url = URL.createObjectURL(dataBlob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'exported_data.xlsx');
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

            const table = document.getElementById(`${tabla}`);
            const wb = XLSX.utils.table_to_book(table);

            /* Export to file (start a download) */
            XLSX.writeFile(wb, `${name}.xlsx`);

    };

    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("listapacientes") ) {
        return( <NoAcceso /> )
    } 
    else {

        {isLoading && <LoadingOverlay />}
        return (
            <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}} >
                <div className='row p-3'>
        
                    
                    <div className="card rounded shadow p-3 mt-3 mb-3">
                        
                        <h5 className='card-title'> <b>FILTROS</b> </h5>
                        
                        <div className='row'>
                               
                            <div className='form-group col-lg-3 col-12 mt-3' >
                                <div className='label'>Inicio </div>
                                <input 
                                    type="date" 
                                    className='form-control' 
                                    name="fechaInicio" 
                                    id="fechaInicio" 
                                    defaultValue= { formatDate(new Date()) }
                                    onChange={ ( ev ) => handleFechaChange( ev )  }
                                    placeholder="Inicio" />
                            </div>
                                
                            <div className="form-group col-lg-3 col-12 mt-3">
                                    <div className='label' > Final </div>
                                    <input
                                        type="date" 
                                        className='form-control' 
                                        name="fechaFinal" 
                                        id="fechaFinal" 
                                        defaultValue= { formatDate(new Date()) }
                                        onChange={ (ev) => setFechaFinal(ev.target.value) }
                                        placeholder="Final" 
                                    />
                                
                            </div>
                                
                            <div className='form-group col-lg-3 col-12 mt-3'>
                                
                                <div className='label'>Tipos Atención</div>
                                <SelectElement
                                    options= { atencion }
                                    name={"uidTipoAtencion"}
                                    isMulti= {false}
                                    closeOnMenuSelect= {true}
                                    onChange= {(ev) => setAtencionSeleccionado( ev === null ? '' : ev.value ) }
                                    classname= "form-control form-control-lg" 
                                    isClearable = {true}
                                />
                            </div>
        
                            <div className='form-group col-lg-3 col-12 mt-3'>
                                
                                <div className='label'>Módulos</div>
                                <SelectElement
                                    options= { modulo }
                                    name={"uidModulo"}
                                    isMulti= {false}
                                    closeOnMenuSelect= {true}
                                    onChange= {(ev) => setModuloSeleccionado( ev === null ? '' : ev.value ) }
                                    classname= "form-control form-control-lg" 
                                    isClearable = {true}
                                />
                            </div>

                            <div className='form-group col-lg-3 col-12 mt-3'>
                                
                                <div className='label'>Agentes</div>
                                <SelectElement
                                    options= { agente }
                                    name={"uidUsuario"}
                                    isMulti= {false}
                                    closeOnMenuSelect= {true}
                                    onChange= {(ev) => setAgenteSeleccionado( ev === null ? '' : ev.value ) }
                                    classname= "form-control form-control-lg" 
                                    isClearable = {true}
                                />
                            </div>

                            <div className=' form-group col-lg-3 col-12 mt-3 '>
                                <div className='label'>Paciente</div>
                                <input
                                    type='text'
                                    name={"buscarPaciente"}
                                    placeholder='Documento o Nombre'
                                    className='form-control'
                                    onChange={ (ev) => onChangeName(ev)}
                                />

                            </div>
        
                        </div>
        
                    </div>
        
                    <div className=' form-group col-12 p-2'>
                        <div className='card shadow' >
                            <div className='card-header'>
                                <div className='card-tools' style={{ float: 'right', marginRight: '-.625rem'  }}>
                                    <button className= 'btn btn-sm btn-link' onClick={() => exportToExcel( "listaPacientes", "Pacientes") }><i className="fa-solid fa-file-excel fa-2x"></i></button>
                                </div>
                            </div>
                            
                            <div className='card-body' id='listaPacientes'>
                               
                                <table width= "100%" className='table table-responsive table-striped   max400' style={{ fontSize: "1rem" }}>
        
                                    <thead width= "100%">
                                        <tr>
                                            <th width={"15%"}>Paciente</th>
                                            <th width={"15%"}>Atención</th>
                                            <th width={"5%"}>Ticket</th>
                                            <th width={"10%"}>Módulo</th>
                                            <th width={"10%"}>Atendió</th>
                                            <th width={"10%"}>Creado</th>
                                            <th width={"10%"}>Llamado</th>
                                            <th width={"10%"}>Atendido</th>
                                            <th width={"7%"}>Tiempo Llamado</th>
                                            <th width={"7%"}>Tiempo Aten </th>
                                        </tr>
                                    </thead>
        
                                    <tbody width= "100%">
                                        {listaAtenciones
                                        .map((item, i) => (
                                            <tr key={ i }>
                                                <td width={"15%"}>
                                                    { 
                                                        item.nombrePaciente.trim() === ""
                                                        ? item.numeroDocumento
                                                        : item.nombrePaciente.trim().toUpperCase() 
                                                    }
                                                </td>
                                                <td width={"15%"}>{ item.tipoAtencion.toUpperCase() }</td>
                                                <td width={"5%"}>{ item.numeroTicket }</td>
                                                <td width={"10%"}>{ item.moduloClase } { item.modulo }</td>
                                                <td width={"10%"}>{ item.agente.toUpperCase() }</td>
                                                <td width={"10%"}>
                                                    { 
                                                        item.createdAt === null 
                                                        ? ""
                                                        : moment(item.createdAt).format('YYYY-MM-DD hh:mm:ss a') 
                                                        
                                                    }
                                                </td>
                                                <td width={"10%"}>
                                                    { 
                                                        item.atendidoEn === null 
                                                        ? ""
                                                        : moment(item.atendidoEn).format('YYYY-MM-DD hh:mm:ss a') 
                                                    }
                                                </td>
                                                <td width={"10%"}>
                                                    { 
                                                        item.terminadoEn === null 
                                                        ? ""
                                                        : moment(item.terminadoEn).format('YYYY-MM-DD hh:mm:ss a') 
                                                    }
                                                </td>
                                                <td width={"7%"}>
                                                    { 
                                                        item.tiempoLlamado === null 
                                                        ? ""
                                                        : item.tiempoLlamado 
                                                            
                                                        
                                                    }
                                                </td>
                                                <td width={"7%"}>
                                                    { 
                                                        item.tiempoAtencion === null 
                                                        ? ""
                                                        : item.tiempoAtencion
                                                            
                                                        
                                                    }
                                                </td>
                                                
                                            </tr>
        
                                        ))}
                                    </tbody>
                                    
                                    <tfoot width= "100%">
                                      
                                    </tfoot>
        
                                </table>
                            </div>
        
                            {/* <div className='card-footer'>
                                footer
                            </div> */}
        
                            
                        </div>
                    </div>
        
                    
        
                
        
                </div>

            </div>
    
        )
    }   
         
}
